var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 228.91 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #1f204c;\n      }\n\n      .cls-4 {\n        fill: #612a68;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 56.35,
    y1: 37.38,
    x2: 86.95,
    y2: 37.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5424e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b2167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -865.47,
    y1: 668.22,
    x2: -832.66,
    y2: 668.22,
    gradientTransform: "translate(-790.36 702.01) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -865.47,
    y1: 644.61,
    x2: -823.21,
    y2: 644.61,
    gradientTransform: "translate(-790.36 702.01) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d3288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b2167"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 228.91,
    height: 100,
    rx: 50,
    ry: 50
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.98,38.7s0,0,0,0c0,0,0,0,0,0,1.23-1.54,1.97-3.5,1.97-5.63s-.73-4.06-1.96-5.6c0,0,0,0,0-.01l-4.86-6.29-2.72,3.52-20.55,26.6c-.95,1.14-.57,2.28,.95,2.28h14.26c1.24,0,1.81-.47,2.38-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.79,27.09c1.22,1.54,1.96,3.48,1.96,5.6s-.74,4.08-1.97,5.63c0,0,0,0,0,0l2.73-3.51s0,0,0,0c1.23-1.54,1.97-3.5,1.97-5.63s-.73-4.06-1.96-5.6c0,0,0,0,0-.01l-4.86-6.29-2.72,3.52,4.85,6.28s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.48,32.48s0,0,0,0c0,0,0,0,0,0-1.23,1.54-1.97,3.5-1.97,5.63s.73,4.06,1.96,5.6c0,0,0,0,0,0l4.86,6.29,2.72-3.52,20.55-26.6c.95-1.14,.57-2.28-.95-2.28h-14.26c-1.24,0-1.81,.48-2.38,1.33l-14.7,18.92,4.17-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.2,40.19c-1.22-1.54-1.96-3.48-1.96-5.6s.74-4.08,1.97-5.63c0,0,0,0,0,0l-2.73,3.51s0,0,0,0c-1.23,1.54-1.97,3.5-1.97,5.63s.73,4.06,1.96,5.6c0,0,0,0,0,0l4.86,6.29,2.72-3.52-4.85-6.28s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.72,80.9c.66,.85,1.24,1.43,2.56,1.43h14.35c1.52,0,1.9-1.23,.95-2.38l-.88-1.14-22.39-28.81h0s-4.86-6.29-4.86-6.29c0,0,0,0,0,0-1.22-1.54-1.96-3.48-1.96-5.6s.74-4.08,1.97-5.63c0,0,0,0,0,0,0,0,0,0,0,0l-4.17,5.37-9.45,12.16,23.87,30.9Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.83,33.93l-.85,4.71h-6.27l-.66,3.78h5.87l-.79,4.52h-5.87l-.79,4.4h6.51l-.82,4.71h-11.43l3.92-22.12h11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.56,39.29l.63,4.49,2.43-4.49h4.76l-5.03,8.12,2.25,8.65h-4.76l-.79-5.05-2.62,5.05h-4.76l5.32-8.65-2.2-8.12h4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.77,38.85c1.61,0,2.79,.38,3.55,1.13,.76,.75,1.14,1.97,1.14,3.64,0,.93-.23,2.59-.69,4.99h-7.07c-.3,1.8-.45,2.82-.45,3.07,0,.93,.32,1.39,.95,1.39,.51,0,.9-.23,1.18-.7s.51-1.2,.7-2.22h4.29c-.41,2.19-1.16,3.79-2.26,4.8-1.1,1.01-2.59,1.52-4.46,1.52-1.69,0-2.94-.36-3.74-1.08-.8-.72-1.2-1.95-1.2-3.69,0-1.09,.16-2.55,.48-4.37s.79-3.37,1.4-4.66,1.44-2.25,2.46-2.88c1.02-.63,2.27-.95,3.73-.95Zm.11,6.72c.18-1.07,.26-1.78,.26-2.11,0-.81-.34-1.21-1.03-1.21-.46,0-.83,.21-1.11,.64-.28,.42-.53,1.32-.74,2.68h2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.79,38.85c1.52,0,2.64,.35,3.37,1.05,.73,.7,1.1,1.83,1.1,3.38,0,.68-.09,1.54-.26,2.57h-4.29c.16-.74,.24-1.38,.24-1.92,0-.99-.33-1.49-1.01-1.49-.53,0-.95,.33-1.26,.99s-.64,1.95-1,3.86c-.36,1.91-.54,3.27-.54,4.07,0,1.01,.31,1.52,.93,1.52,.56,0,1-.28,1.3-.85s.56-1.56,.77-2.99h4.29c-.41,2.6-1.16,4.49-2.25,5.67-1.09,1.18-2.67,1.77-4.74,1.77-1.76,0-3.03-.38-3.81-1.15-.78-.76-1.16-2.07-1.16-3.9s.31-3.95,.94-6.15c.63-2.2,1.5-3.82,2.62-4.87,1.12-1.04,2.71-1.56,4.78-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.25,39.29l-1.91,10.75c-.11,.52-.16,.93-.16,1.24,0,.7,.3,1.05,.9,1.05,.42,0,.75-.15,.99-.46,.24-.31,.42-.82,.54-1.52l1.96-11.06h4.76l-2.96,16.76h-4.6l.34-2.05h-.05c-.93,1.65-2.24,2.48-3.92,2.48-2.05,0-3.07-1.01-3.07-3.04,0-.21,.03-.52,.08-.93,.05-.41,.83-4.82,2.33-13.23h4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.57,34.36l-.87,4.93h1.88l-.66,3.75h-1.88c-.99,5.54-1.48,8.36-1.48,8.46,0,.33,.08,.55,.25,.67,.17,.11,.42,.17,.75,.17h.69l-.64,3.72c-1,.12-1.9,.19-2.67,.19-1.38,0-2.29-.19-2.75-.56-.46-.37-.69-1-.69-1.89,0-.27,.01-.53,.04-.79s.6-3.58,1.73-9.96h-1.59l.66-3.75h1.59l.87-4.93h4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.42,39.29l-2.96,16.76h-4.76l2.96-16.76h4.76Zm.95-5.36l-.74,4.15h-4.76l.74-4.15h4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.14,38.85c1.69,0,2.95,.38,3.76,1.13,.81,.75,1.22,1.98,1.22,3.67,0,1.57-.28,3.54-.85,5.92-.56,2.38-1.44,4.12-2.62,5.24-1.18,1.12-2.73,1.67-4.63,1.67-1.69,0-2.95-.37-3.76-1.1-.81-.73-1.22-1.94-1.22-3.61s.29-3.74,.86-6.09,1.45-4.07,2.63-5.18c1.18-1.1,2.72-1.66,4.6-1.66Zm-3.39,12.67c0,.52,.07,.87,.21,1.07,.14,.2,.37,.29,.69,.29,.49,0,.89-.3,1.2-.91s.64-1.97,1.01-4.08c.36-2.11,.54-3.48,.54-4.12,0-.52-.07-.87-.21-1.05-.14-.19-.38-.28-.71-.28-.49,0-.89,.32-1.19,.96-.3,.64-.63,1.97-.99,3.98-.36,2.01-.54,3.39-.54,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.84,38.85c1.13,0,1.92,.27,2.38,.81,.46,.54,.69,1.28,.69,2.23,0,.41-.06,.99-.19,1.73l-2.2,12.43h-4.76l1.9-10.75c.09-.45,.13-.87,.13-1.24,0-.41-.08-.69-.24-.84-.16-.14-.38-.22-.66-.22-.44,0-.77,.16-.99,.48-.22,.32-.39,.82-.52,1.5l-1.96,11.06h-4.76l2.96-16.76h4.6l-.37,2.04h.05c.92-1.63,2.22-2.46,3.92-2.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.6,60.2l-.87,4.9h-3.71l-3.04,17.23h-4.92l3.04-17.23h-3.7l.87-4.9h12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.91,60.2l-.85,4.71h-6.27l-.66,3.78h5.87l-.79,4.52h-5.87l-.79,4.4h6.51l-.82,4.71h-11.43l3.92-22.12h11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.21,59.77c3.39,0,5.08,1.61,5.08,4.83,0,.62-.15,1.81-.45,3.56h-4.76l.21-1.21c.14-.76,.21-1.4,.21-1.92,0-.91-.33-1.36-.98-1.36-.69,0-1.22,.44-1.59,1.33-.37,.89-.83,2.93-1.39,6.12-.56,3.19-.83,5.21-.83,6.06,0,.62,.08,1.05,.25,1.3,.17,.25,.45,.37,.86,.37,.37,0,.67-.13,.91-.39s.46-.67,.66-1.24c.2-.57,.49-1.83,.86-3.8h4.76c-.37,2.38-.81,4.09-1.32,5.14-1.32,2.79-3.52,4.18-6.59,4.18-1.94,0-3.32-.44-4.13-1.32-.81-.88-1.22-2.27-1.22-4.17,0-2.19,.37-4.97,1.12-8.35,.75-3.38,1.76-5.75,3.04-7.11,1.28-1.36,3.04-2.05,5.28-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.07,60.2l-1.46,8.12h3.02l1.46-8.12h4.92l-3.92,22.12h-4.92l1.61-9.11h-3.02l-1.61,9.11h-4.92l3.92-22.12h4.92Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.c6a85521f1e5a229b70b748367c19b3c.svg";
export { ForwardRef as ReactComponent };